import { useUnit } from 'effector-react'

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/components/ui/tabs.tsx'
import { $creatorId } from '@/models/creators'
import { TrackedFeatures, trackFeatureUsage } from '@/utils/feature-engagement'

import { CreatorInfoContent } from './creator-info-content'
import { FanInfoContent } from './fan-info-content'

export const InfoTabs = () => {
  const creatorId = useUnit($creatorId)

  const onTabChange = (value: string) => {
    if (value === 'creator-info') {
      trackFeatureUsage(TrackedFeatures.CreatorInfo, creatorId)
    }
  }

  return (
    <Tabs
      defaultValue="fan-info"
      className="w-full"
      onValueChange={onTabChange}
    >
      <TabsList className="grid w-full grid-cols-2 bg-secondary-50 dark:bg-secondary-600 dark:border-border-default border-2">
        <TabsTrigger value="fan-info">Fan Info</TabsTrigger>
        <TabsTrigger value="creator-info">Creator Info</TabsTrigger>
      </TabsList>
      <TabsContent
        value="fan-info"
        className="mt-4"
      >
        <FanInfoContent />
      </TabsContent>
      <TabsContent
        value="creator-info"
        className="mt-4"
      >
        <CreatorInfoContent />
      </TabsContent>
    </Tabs>
  )
}
